import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';
import { isAllOrEmpty } from './builders.utils';

// translatable: tillage values map to localized labels (e.g. labour -> Plowing, non_labour -> No Plowing).
export const buildTillageFilter = (): Filter =>
  buildFilter<RegionalOverviewProperties>({
    type: RegionalOverviewFilterType.TILLAGE,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: true,
    getValues: feature => {
      const tillage = feature.properties?.tillage;
      return tillage ? [tillage] : [];
    },
    matches: (feature, value) => {
      if (isAllOrEmpty(value)) return true;
      const tillage = feature.properties?.tillage;
      if (!tillage) return false;
      return (value as string[]).includes(tillage);
    }
  });
